.Trigger {
  display: inline-flex;
  align-items: center;
  user-select: none;
  gap: 0.5ch;
  padding: 0.25ch 1ch;
  border-radius: 0.5rem;
  background-color: var(--color-button-background);
  cursor: pointer;
}
